import api from './index';
//
let exports = {};
// --------------------- 项目模板 --------------------------
// 项目模版分页列表
exports.getProjTplPageList = function (params, callback) {
    api.post('/proj/tpl/page/list/get')
        .data(params)
        .done(callback)
        .go();
};
// 项目模版查询
exports.getProjTpl = function (params, callback) {
    api.post('/proj/tpl/get')
        .data(params)
        .done(callback)
        .go();
};

// --------------------- 项目信息 --------------------------
// 项目信息查询
exports.getProjInfo = function (data, callback) {
    api.post('/proj/info/get')
        .data(data)
        .done(callback)
        .go();
};
// 项目信息分页列表
exports.getProjInfoPageList = function (data, callback) {
    api.post('/proj/info/page/list/get')
        .data(data)
        .done(callback)
        .go();
};
// 新增项目
exports.createProjInfo = function (data, callback) {
    api.post('/proj/info/create/do')
        .data(data)
        .done(callback)
        .go();
};
// 编辑
exports.modifyProjInfo = function (data, callback) {
    api.post('/proj/info/modify/do')
        .data(data)
        .done(callback)
        .go();
};

// 项目信息启动操作
exports.doModifyProjInfoPhaseToEstimat = function (data, callback) {
    api.post('/proj/info/phase/to/estimat/modify/do')
        .data(data)
        .done(callback)
        .go();
};

// 项目信息规划设计操作
exports.doModifyProjInfoPhaseToPlanDesign = function (data, callback) {
    api.post('/proj/info/phase/to/planDesign/modify/do')
        .data(data)
        .done(callback)
        .go();
};

// 项目执行操作
exports.doModifyProjInfoPhaseToExecuteCheck = function (data, callback) {
    api.post('/proj/info/phase/to/executeCheck/modify/do')
        .data(data)
        .done(callback)
        .go();
};

// 删除项目信息
exports.doDeleteProjInfo = function (data, callback) {
    api.post('/proj/info/delete/do')
        .data(data)
        .done(callback)
        .go();
};
// 冻结项目
exports.doFrozenProjInfo = function (data, callback) {
    api.post('/proj/info/frozen/do')
        .data(data)
        .done(callback)
        .go();
};

// 解冻项目
exports.doUnFrozenProjInfo = function (data, callback) {
    api.post('/proj/info/unFrozen/do')
        .data(data)
        .done(callback)
        .go();
};

// 项目异常终止
exports.doUpdateProjInfoAborted = function (data, callback) {
    api.post('/proj/info/aborted/update/do')
        .data(data)
        .done(callback)
        .go();
};

// 项目异常终止审核
exports.doAuditProjInfoAborted = function (data, callback) {
    api.post('/proj/info/aborted/audit/do')
        .data(data)
        .done(callback)
        .go();
};

// 项目竣工验收
exports.doAcceptedProjInfo = function (data, callback) {
    api.post('/proj/info/accepted/do')
        .data(data)
        .done(callback)
        .go();
};

// 结束项目
exports.doCompletedProjInfo = function (data, callback) {
    api.post('/proj/info/completed/do')
        .data(data)
        .done(callback)
        .go();
};

// 关闭项目
exports.doClosedProjInfo = function (data, callback) {
    api.post('/proj/info/closed/do')
        .data(data)
        .done(callback)
        .go();
};

// 作废项目信息
exports.doInvalidProjInfo = function (data, callback) {
    api.post('/proj/info/invalid/do')
        .data(data)
        .done(callback)
        .go();
};

// --------------------- 项目结构清单、明细清单信息 --------------------------

exports.getProjSubItemInfoById = function (data, callback) {
    api.post('/proj/sub/item/info/get')
        .data(data)
        .done(callback)
        .go();
};

// 项目清单树形列表
exports.getProjSubItemTreeList = function (data, callback) {
    api.post('/proj/sub/item/tree/list/get')
        .data(data)
        .done(callback)
        .go();
};
// 项目结构清单编辑
exports.modifyProjSubItem = function (data, callback) {
    api.post('/proj/sub/item/modify/do')
        .data(data)
        .done(callback)
        .go();
};
// 项目结构清单删除
exports.deleteProjSumItemById = function (data, callback) {
    api.post('/proj/sub/item/remove/do')
        .data(data)
        .done(callback)
        .go();
};

// 项目明细清单保存
exports.createProjSubItemDetail = function (data, callback) {
    api.post('/proj/sub/item/detail/create/do')
        .data(data)
        .done(callback)
        .go();
};

exports.doProjSubItemListImpCheck = function (data, callback) {
    api.post('/proj/sub/item/imp/check/do')
        .data(data)
        .done(callback)
        .go();
};

exports.doProjSubItemDetailListImpCheck = function (data, callback) {
    api.post('/proj/sub/item/detail/imp/check/do')
        .data(data)
        .done(callback)
        .go();
};
exports.createProjSubItemDetailListImp = function (data, callback) {
    api.post('/proj/sub/item/detail/imp/create/do')
        .data(data)
        .done(callback)
        .go();
};

// --------------------- 项目合约 --------------------------

// 获取项目合约列表
exports.getProjCntrctCOPageList = function (data, callback) {
    api.post('/proj/cntrct/page/list/get')
        .data(data)
        .done(callback)
        .go();
};
// 获取项目合约详情
exports.getProjCntrctInfo = function (params, callback) {
    api.get('/proj/cntrct/info/get')
        .params(params)
        .done(callback)
        .go();
};
// 新增项目合约
exports.doSaveProjCntrct = function (data, callback) {
    api.post('/proj/cntrct/save/do')
        .data(data)
        .done(callback)
        .go();
};
// 修改项目合约
exports.doUpdateProjCntrct = function (data, callback) {
    api.post('/proj/cntrct/update/do')
        .data(data)
        .done(callback)
        .go();
};

// --------------------- 项目成员 --------------------------
// 项目组成员列表
exports.getProjCrewWorkList = function (data, callback) {
    api.post('/proj/crew/work/list/get')
        .data(data)
        .done(callback)
        .go();
};

// 项目组成员保存
exports.saveProjCrewWork = function (data, callback) {
    api.post('/proj/crew/work/save/do')
        .data(data)
        .done(callback)
        .go();
};

// 项目组成员编辑
exports.updateProjCrewWork = function (data, callback) {
    api.post('/proj/crew/work/update/do')
        .data(data)
        .done(callback)
        .go();
};

// 项目组成员删除
exports.deleteProjCrewWork = function (data, callback) {
    api.post('/proj/crew/work/delete/do')
        .data(data)
        .done(callback)
        .go();
};

// 项目组成员设置项目经理
exports.doProjCrewWorkLeaderFlag = function (data, callback) {
    api.post('/proj/crew/work/leaderFlag/update/do')
        .data(data)
        .done(callback)
        .go();
};

// --------------------- 违约管理 --------------------------
// 违约管理列表
exports.getProjViolateItemList = function (data, callback) {
    api.post('/proj/violate/item/list/get')
        .data(data)
        .done(callback)
        .go();
};
// 违约管理分页列表
exports.getProjViolateItemPageList = function (data, callback) {
    api.post('/proj/violate/item/page/list/get')
        .data(data)
        .done(callback)
        .go();
};
// 违约管理查询
exports.getProjViolateItem = function (data, callback) {
    api.post('/proj/violate/item/get')
        .data(data)
        .done(callback)
        .go();
};
// 违约记录保存
exports.saveProjViolateItem = function (data, callback) {
    api.post('/proj/violate/item/save/do')
        .data(data)
        .done(callback)
        .go();
};
// 违约记录删除
exports.deleteProjViolateItem = function (data, callback) {
    api.post('/proj/violate/item/delete/do')
        .data(data)
        .done(callback)
        .go();
};
// 违约记录处罚
exports.doProjViolateItemHandle = function (data, callback) {
    api.post('/proj/violate/item/handle/do')
        .data(data)
        .done(callback)
        .go();
};

// --------------------- 项目文档管理 --------------------------
// 项目目录列表
exports.getProjFolderCOTreeList = function (data, callback) {
    api.post('/proj/folder/tree/list/get')
        .data(data)
        .done(callback)
        .go();
};

// 获取项目目录详情
exports.getProjFolderCO = function (params, callback) {
    api.get('/proj/folder/get')
        .params(params)
        .done(callback)
        .go();
};

// 项目目录保存
exports.saveProjFolder = function (data, callback) {
    api.post('/proj/folder/save/do')
        .data(data)
        .done(callback)
        .go();
};

// 项目目录批量保存
exports.saveProjFolderList = function (data, callback) {
    api.post('/proj/folder/list/save/do')
        .data(data)
        .done(callback)
        .go();
};

// 修改项目目录
exports.updateProjFolder = function (data, callback) {
    api.post('/proj/folder/update/do')
        .data(data)
        .done(callback)
        .go();
};

// 删除项目目录
exports.doDeleteProjFolder = function (data, callback) {
    api.post('/proj/folder/delete/do')
        .data(data)
        .done(callback)
        .go();
};

// 获取项目文档列表
exports.getProjFileCOList = function (data, callback) {
    api.post('/proj/file/list/get')
        .data(data)
        .done(callback)
        .go();
};

// 获取项目文档详情
exports.getProjFileCO = function (params, callback) {
    api.get('/proj/file/get')
        .params(params)
        .done(callback)
        .go();
};

// 批量保存项目文档
exports.saveProjFileList = function (data, callback) {
    api.post('/proj/file/list/save/do')
        .data(data)
        .done(callback)
        .go();
};

// 删除项目文档
exports.doDeleteProjFile = function (data, callback) {
    api.post('/proj/file/delete/do')
        .data(data)
        .done(callback)
        .go();
};

// 项目文档设置标签
exports.updateProjFileBizTagByIds = function (data, callback) {
    api.post('/proj/file/bizTag/update/do')
        .data(data)
        .done(callback)
        .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/proj.js
// module id = 55
// module chunks = 0